import React from 'react'
import styles from './styles.css'
import {Form, Field} from 'simple-react-form'
import Filler from './Filler'
import PropTypes from 'prop-types'
import autobind from 'autobind-decorator'
import Checkbox from './Checkbox'
import TextSize from './TextSize'
import DeleteIcon from 'react-icons/lib/md/delete'
import IconButton from 'orionsoft-parts/lib/components/IconButton'
import Text from './Text'
import Value from './Value'
import Select from './Select'

export default class Menu extends React.Component {
  static propTypes = {
    field: PropTypes.object,
    onUpdate: PropTypes.func,
    document: PropTypes.object,
    delete: PropTypes.func
  }

  @autobind
  onChange({filler, required, value, name, validation, textSize}) {
    console.log("TS: " +  JSON.stringify(textSize) );
    this.props.onUpdate({
      filler: filler || null,
      required: !!required,
      value: filler ? null : value,
      name: name || null,
      validation: validation || null,
      textSize: textSize || null
    })
  }

  renderRequired() {
    if (!this.props.field.filler) return null
    return <Field fieldName="required" label="Requerido" type={Checkbox} />
  }

  renderFieldName() {
    if (!this.props.field.filler || this.props.field.type === 'signature') {
      return
    }
    return <Field fieldName="name" type={Text} field={this.props.field} />
  }

  renderFieldValidation() {
    if (
      !this.props.field.filler ||
      this.props.field.type === 'signature' ||
      this.props.field.type === 'checkbox' ||
      this.props.field.type === 'textSize'
    ) {
      return
    }
    return <Field fieldName="validation" type={Select} field={this.props.field} />
  }

  // dentro validar que si no existe firmante, no pescar el validation
  renderFillNow() {
    if (this.props.field.filler) return
    return (
      <div className={styles.value}>
        <Field
          fieldName="value"
          type={Value}
          document={this.props.document}
          field={this.props.field}
        />
      </div>
    )
  }

  

  renderSizeSelect(){
    console.log("Pare render SS: " + JSON.stringify(this.props.field));
    
    return (
      <div>
        <div className={styles.label}>Tamaño de fuente</div>
        <Field
          fieldName="textSize"
          type={TextSize}
          document={this.props.document}
          field={this.props.field}
        />
      </div>
    )
  }

  renderFiller() {
    if (!this.props.document.signers) return
    return (
      <div>
        <div className={styles.label}>¿Quien completa este campo?</div>
        <Field fieldName="filler" type={Filler} document={this.props.document} />
      </div>
    )
  }

  render() {
    return (
      <div className={styles.container}>
        <div className={styles.arrow} />
        <div>
          <Form state={this.props.field} onChange={this.onChange}>
            {this.renderFiller()}
            {this.props.field.type !== 'checkbox' ? this.renderFieldValidation() : null}
            {this.renderFieldName()}
            {this.props.field.type === 'text' ? this.renderSizeSelect() : null}
            {this.props.field.type !== 'checkbox' ? this.renderRequired() : null}
            {this.renderFillNow()}
          </Form>
        </div>
        <div className={styles.delete}>
          <IconButton tooltip="Borrar" size={20} icon={DeleteIcon} onPress={this.props.delete} />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Sign/Prepare/Field/Menu/index.js